import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enCommon from './locales/en/common.json';
import enAuth from './locales/en/auth.json';
import enQueue from './locales/en/queue.json';

import frCommon from './locales/fr/common.json';
import frAuth from './locales/fr/auth.json';
import frQueue from './locales/fr/queue.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        common: enCommon,
        auth: enAuth,
        queue: enQueue
      },
      fr: {
        common: frCommon,
        auth: frAuth,
        queue: frQueue
      }
    },
    fallbackLng: 'en',
    defaultNS: 'common',
    ns: ['common', 'auth', 'queue'],
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng'
    }
  });

i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng === 'fr' ? 'fr-CA' : 'en-US';
});

document.documentElement.lang = i18n.language === 'fr' ? 'fr-CA' : 'en-US';

export default i18n;
